interface CustomNavigator extends Navigator {
    standalone?: boolean;
}

export const checkStandalone = (): boolean => {
    const navigator = window.navigator as CustomNavigator;

    // Verifica si la PWA está en modo standalone en iOS
    const iOSStandalone = navigator.standalone === true;

    // Verifica si la PWA está en modo standalone en Android y otros navegadores
    const displayMode = window.matchMedia('(display-mode: standalone)').matches;

    return (iOSStandalone || displayMode);
};